module.exports = __webpack_public_path__ + "static/media/masala.eb9571da.jpg";